import { render } from "./UserDetailsForm.vue?vue&type=template&id=56d84562"
import script from "./UserDetailsForm.vue?vue&type=script&lang=js"
export * from "./UserDetailsForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/LCAP/LCAP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__